import { Component, OnInit, ViewChild, ElementRef, Input } from "@angular/core";
import { Reader } from "src/app/models/reader";
import * as JsBarcode from "jsbarcode";
import MD5 from "crypto-js/md5";

@Component({
  selector: "reader-barcode",
  templateUrl: "./reader-barcode.component.html",
  styleUrls: ["./reader-barcode.component.scss"],
})
export class ReaderBarcodeComponent implements OnInit {
  @ViewChild("barcode") barcode: ElementRef;

  @Input() public reader: Reader;

  constructor() {}

  ngOnInit(): void {}
  ngAfterViewInit(): void {
    if (this.reader)
      JsBarcode(
        this.barcode.nativeElement,
        "L" + this.reader.id.toString() + this.getBirthdateHash(),
        {
          width: this.getBirthdateHash().length > 0 ? 1 : 1.8,
          height: 50,
          displayValue: false,
          font: "Arial",
          textPosition: "top",
          textMargin: 0,
          fontSize: 12,
          margin: 0,
        }
      );
  }

  get ReaderLabel() {
    if (
      this.reader.readerClass.statisticsCategory.label
        .toLowerCase()
        .includes("weiblich")
    ) {
      return "Leserin";
    } else if (
      this.reader.readerClass.statisticsCategory.label
        .toLowerCase()
        .includes("männlich")
    ) {
      return "Leser";
    } else {
      return "Leser*in";
    }
  }

  getBirthdateHash() {
    if (this.reader.birthdate && this.reader.birthdate.length > 5)
      return "x" + MD5(this.reader.birthdate).toString().substring(0, 4);
    return "";
  }
}
